import { DataGrid } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import type { CustomChartTablePayload } from '@/entities/dashboards';
import { ChartCardShell } from '../ChartCardShell';
import { chartTableHeight, chartTableStyle } from '../chartLayout';
import { buildTableColumns, toIndexedRows, useSortedTableRows } from './chartTable';

type Props = {
  title: string;
  payload: CustomChartTablePayload;
  /** Высота диаграммы задана пользователем — таблица прокручивает строки внутри неё */
  hasFixedHeight?: boolean;
};

/** Таблица: колонки и строки приходят готовыми — клиент их не пересчитывает. */
export const TableChartView: FC<Props> = ({ title, payload, hasFixedHeight }) => {
  const columns = useMemo(() => buildTableColumns(payload.columns, payload.rows), [payload.columns, payload.rows]);
  const indexedRows = useMemo(() => toIndexedRows(payload.rows), [payload.rows]);
  const { rows, sorting, onSortingChange } = useSortedTableRows(indexedRows, payload.columns);

  return (
    <ChartCardShell title={title} scrollable={false}>
      <DataGrid
        columns={columns}
        dataSource={{ mode: 'client', data: rows }}
        getRowId={(row) => row.key}
        enableColumnResizing
        sorting={sorting}
        onSortingChange={onSortingChange}
        height={chartTableHeight(rows.length, hasFixedHeight)}
        style={chartTableStyle(hasFixedHeight)}
      />
    </ChartCardShell>
  );
};
